import Vue from "vue";
import Router from "vue-router";

Vue.use(Router)
 
const router = new Router({
    mode: "hash", 
    routes: [
        {
            path: '/',
            redirect: 'coolDati',
        },
        {
            path: "/coolDati",
            name: "coolDati",
            component: () =>
                import ('@/components/coolDati.vue'),
            meta: {
                title: '酷丁编程答题',
                icon: '',
                code: "coolDati",
                hidden: true,
            },
        },
        {
            path: "/coolStudent",
            name: "coolStudent",
            component: () =>
                import ('@/components/coolStudent.vue'),
            meta: {
                title: '酷丁编程答题',
                icon: '',
                code: "coolStudent",
                hidden: true,
            },
        },
        {
            path: "/questionnaire",
            name: "questionnaire",
            component: () =>
                import ('@/components/questionnaire.vue'),
            meta: {
                title: '活动预约详情',
                icon: '',
                code: "questionnaire",
                hidden: true,
            },
        },
        {
            path: "/sign",
            name: "sign",
            component: () =>
                import ('@/components/sign.vue'),
            meta: {
                title: '活动预约签到',
                icon: '',
                code: "sign",
                hidden: true,
            },
        },
        {
            path: "/clsSatisfaction",
            name: "clsSatisfaction",
            component: () =>
                import('@/components/clsSatisfaction.vue'),
            meta: {
                title: '满意度调查问卷',
                icon: '',
                code: "clsSatisfaction",
                hidden: true,
            },
        },
        {
            path: "/satisfaction",
            name: "satisfaction",
            component: () =>
                import('@/components/satisfaction.vue'),
            meta: {
                title: '通用调查问卷',
                icon: '',
                code: "satisfaction",
                hidden: true,
            },
        },
    ]
    });

    router.beforeEach((to, from, next) => {
        next();
    });
    
    router.afterEach(route => {
        // ()

    });
    
    export default router;